const ACCESS_TOKEN = 'd5f398b8dfe34f831094c422a65bdac0'

if (!ACCESS_TOKEN) {
  alert(
    'Please set Storefront API access token in dev/js/components/api.js using the Headless App',
  )
}

export const fetchFromApi = async query => {
  const response = await fetch('/api/2021-10/graphql.json', {
    credentials: 'include',
    method: 'post',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
    },
    body: query,
  })

  return response.json()
}
